import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    {
        name: "About the Department",
        link: "#",
        content: (
            <div>
                <p>
                    Global literature, literary theory, aesthetics, fine arts, music and musicology,
                    theatre and dramaturgy, etc., fall under this department, which plays an important role in public life...
                </p>
                <ul>
                    <li>To establish Sanskrit language on a global platform through literature.</li>
                    <li>Development, study, and teaching of various branches.</li>
                    <li>Promoting both theoretical and practical aspects of drama and acting.</li>
                    <li>Promotion of Indian knowledge traditions.</li>
                </ul>
            </div>
        )
    },
    {
        name: "Courses Offered",
        link: "#",
        content: (
            <ul>
                <li>Shastri (Literature)</li>
                <li>Aacharya (Literature)</li>
                <li>Vidyavaridhi (Ph.D.)</li>
            </ul>
        )
    },
    {
        name: "Faculty Members",
        link: "#",
        content: (
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                        <th>Name</th>
                        <th>Designation</th>
                        <th>Qualification</th>
                        <th>Contact</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Dr. Jagat Narayan</td>
                        <td>Head of Department, Associate Professor</td>
                        <td>Ph.D</td>
                        <td>9996041064</td>
                        <td><a href="mailto:hodsahitya@mvsu.ac.in">hodsahitya@mvsu.ac.in</a></td>
                    </tr>
                    <tr>
                        <td>Dr. Ramanand Mishra</td>
                        <td>Assistant Professor</td>
                        <td>Ph.D, NET</td>
                        <td>7355115414</td>
                        <td><a href="mailto:ramachd91@gmail.com">ramachd91@gmail.com</a></td>
                    </tr>
                    <tr>
                        <td>Dr. Krishna Chandra Pandey</td>
                        <td>Assistant Professor</td>
                        <td>Ph.D</td>
                        <td>9810373278</td>
                        <td><a href="mailto:krishnapanday1967@gmail.com">krishnapanday1967@gmail.com</a></td>
                    </tr>
                </tbody>
            </table>
        )
    },
    {
        name: "Timetable",
        link: "#",
        content: <p>Information related to the timetable will be made available soon.</p>
    },
    {
        name: "Facilities",
        link: "#",
        content: <p>The Literature Department provides a library, research room, and other essential facilities.</p>
    },
    {
        name: "Seminars/Conferences/Workshops",
        link: "#",
        content: <p>The department regularly organizes research seminars and workshops.</p>
    },
    {
        name: "Research Scholars",
        link: "#",
        content: (
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                        <th>Scholar</th>
                        <th>Supervisor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Pushpa</td><td>Dr. Jagat Narayan</td></tr>
                    <tr><td>Kuldeep Kumar</td><td>Dr. Jagat Narayan</td></tr>
                    <tr><td>Neelam</td><td>Dr. Jagat Narayan</td></tr>
                    <tr><td>Ajay</td><td>Dr. Jagat Narayan</td></tr>
                    <tr><td>Sonia</td><td>Dr. Jagat Narayan</td></tr>
                    <tr><td>Shweta</td><td>Dr. Ramanand Mishra</td></tr>
                    <tr><td>Pyare Lal</td><td>Dr. Ramanand Mishra</td></tr>
                    <tr><td>Ila</td><td>Dr. Krishna Chandra Pandey</td></tr>
                    <tr><td>Suman Lata</td><td>Dr. Krishna Chandra Pandey</td></tr>
                    <tr><td>Rohit Kumar</td><td>Dr. Krishna Chandra Pandey</td></tr>
                </tbody>
            </table>
        )
    },
    {
        name: "Achievements",
        link: "#",
        content: (
            <>
                <h6>NET Qualified Students</h6>
                <ul>
                    <li>Dimple (2020-22)</li>
                    <li>Poonam (2022-24)</li>
                    <li>Ritika (2023-25)</li>
                </ul>
                <h6>Selection in Government Services</h6>
                <ul>
                    <li>Anju - Sanskrit Teacher (DSSSB)</li>
                    <li>Shweta - PGT (Mewat, Haryana)</li>
                </ul>
            </>
        )
    },
    {
        name: "Contact",
        link: "#",
        content: (
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                        <th>Name</th>
                        <th>Designation</th>
                        <th>Contact</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Dr. Jagat Narayan</td>
                        <td>Associate Professor & Head</td>
                        <td>99960-41064</td>
                    </tr>
                    <tr>
                        <td>Dr. Ramanand Mishra</td>
                        <td>Assistant Professor</td>
                        <td>73551-15414</td>
                    </tr>
                    <tr>
                        <td>Dr. Krishna Chandra Pandey</td>
                        <td>Assistant Professor</td>
                        <td>98103-73278</td>
                    </tr>
                </tbody>
            </table>
        )
    },
];

export default function LiteratureDepartment_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [selectedDeptIndex, setSelectedDeptIndex] = useState(0);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
                aria-label="Toggle Menu"
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">Department of Literature</h5>
                <nav className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <a
                            href="#!"
                            key={index}
                            className={`d-block mb-1 p-2 rounded small text-decoration-none ${selectedDeptIndex === index ? 'bg-info text-white fw-bold' : 'text-dark'}`}
                            onClick={(e) => {
                                e.preventDefault();
                                setSelectedDeptIndex(index);
                                if (window.innerWidth < 768) setShowSidebar(false);
                            }}
                        >
                            {dept.name}
                        </a>
                    ))}
                </nav>
            </aside>


            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                <h4 className="mb-3 text-primary text-center">{departments[selectedDeptIndex].name}</h4> {/* This line displays the header */}
                {departments[selectedDeptIndex].content}
            </main>
        </div>
    );
}
